import { useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useToaster } from "utils";
import { useBlogPost, blogApi, BlogPostFormValues, SectionFormValues } from "api/shop";
import { BlogPostForm } from "./Forms/BlogPostForm";
import { PaziaBox, PaziaTabs } from "components/atoms";
import { PaziaLoader } from "components/atoms";
import { SectionsList } from "../Sections/SectionsList";
import { BLOG_SECTION_TYPE_OPTIONS } from "consts/sectionTypes";

export const BlogPostEditPage = () => {
  const { blogPostId } = useParams();
  const { blogPost, isLoading, invalidate } = useBlogPost(blogPostId);
  const { showSuccess, showError } = useToaster();
  const [isSaving, setIsSaving] = useState(false);
  const [activeTab, setActiveTab] = useState<"settings" | "sections">("settings");

  const onSubmit = async (data: BlogPostFormValues) => {
    if (!blogPostId) return;
    setIsSaving(true);
    try {
      await blogApi.updateBlogPost(Number(blogPostId), data);
      showSuccess("Zaktualizowano wpis");
      invalidate();
    } catch (e) {
      showError("Nie udało się zaktualizować wpisu");
      console.error(e);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!blogPost) return null;

  const tabs = [
    {
      name: "Ustawienia",
      active: activeTab === "settings",
      onClick: () => setActiveTab("settings"),
    },
    {
      name: "Sekcje",
      active: activeTab === "sections",
      onClick: () => setActiveTab("sections"),
    },
  ];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Blog", path: routes.SHOP_BLOG },
          { title: blogPost.title },
        ]}
        headerText={blogPost.title}
      />
      <PaziaBox>
        <PaziaTabs tabs={tabs} className="mb-4" />
        {activeTab === "settings" && <BlogPostForm onSubmit={onSubmit} blogPost={blogPost} isLoading={isSaving} />}
        {activeTab === "sections" && (
          <SectionsList
            landingPageId={Number(blogPostId)}
            sections={blogPost.sections ?? []}
            onUpdate={invalidate}
            typeOptions={BLOG_SECTION_TYPE_OPTIONS}
            onCreateSection={async (data: SectionFormValues) => {
              await blogApi.createBlogSection(Number(blogPostId), data);
            }}
            onUpdateSection={async (sectionId: number, data: SectionFormValues) => {
              await blogApi.updateBlogSection(Number(blogPostId), sectionId, data);
            }}
            onDeleteSection={(sectionId: number) => blogApi.deleteBlogSection(Number(blogPostId), sectionId)}
            onReorderSections={async (sectionIds: number[]) => {
              await blogApi.reorderBlogSections(Number(blogPostId), sectionIds);
            }}
          />
        )}
      </PaziaBox>
    </PageMain>
  );
};
